import styled from 'styled-components/macro';

export const AllTicketBox = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ButtonHolder = styled.div`
  min-height: 45px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  justify-content: flex-start;
  padding: 10px 12px 0 60px;
`;
